import { render, staticRenderFns } from "./serverCard.vue?vue&type=template&id=18bbf806&"
import script from "./serverCard.vue?vue&type=script&lang=js&"
export * from "./serverCard.vue?vue&type=script&lang=js&"
import style0 from "./serverCard.vue?vue&type=style&index=0&id=18bbf806&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports